import { BaseService } from "./BaseService";

export const PlanoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('planos-aquisicoes/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos planos de aquisição:', error);
            return false;
        }
    },
    async sketch(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('planos-aquisicoes/sketch', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante o salvamento do plano de aquisição:', error);
            return false;
        }
    },
    async consolidate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('planos-aquisicoes/consolidate', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante o salvamento da consolidação:', error);
            return false;
        }
    },
    async historic(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('planos-aquisicoes/historic', postData, true);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca do histórico:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`planos-aquisicoes/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca do histórico:', error);
            return false;
        }
    },
    async download(id) {
        try {
            return await BaseService.downloadItemPost(`planos-aquisicoes/pdf/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a tentativa de download:', error);
            return false;
        }
    }
}